import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getCollectionsSettings,
  updateCollectionsSettings,
} from '../../../api/collectionsSettings';
import { queryKeys } from '../../../api/queryKeys';
import { useToast } from '../../../hooks/useToast';
import type { CollectionsSettingsDto } from '../../../types/api';

export function useCollectionsSettings() {
  return useQuery<CollectionsSettingsDto>({
    queryKey: queryKeys.collectionsSettings.all,
    queryFn: getCollectionsSettings,
    staleTime: 15 * 60 * 1000, // Server caches for 30min; 15min client staleTime is safe
  });
}

export function useUpdateCollectionsSettings() {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (input: Partial<CollectionsSettingsDto>) =>
      updateCollectionsSettings(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.collectionsSettings.all });
      toast.success('Collections settings saved.');
    },
    onError: () => {
      toast.error('Failed to save collections settings.');
    },
  });
}
